import { types, actions } from './requests'
export const DELETEPACKAGE_TYPES = {
    ...types('DELETEPACKAGE'),
}
export const DELETEPACKAGE_ACTIONS = {
    ...actions('DELETEPACKAGE'),
}